import React from "react";
import { Link } from "react-router-dom";
import { Modal, Row, Col } from "react-bootstrap";
import { Tooltip } from "@mui/material";
import config from "../../config";
import { imgPath } from "../../utils/imagePath";
import PropTypes from "prop-types";

const Details = (props) => {
  const { userdata } = props;

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'scroll', overflowX: 'hidden', }}>
        <Row className="mentor_detail">
          <Col md={4}>
            <div className="mentor_pic">
              <img src={userdata.image} alt="user" />
              <div className="mentor_name">
                <h3>{userdata.full_name}</h3>
                <h5>
                  <span>{userdata.position}</span>
                  {userdata.organization}
                </h5>
                <h5>
                  <span></span>
                  {userdata.main_area}
                </h5>
              </div>
            </div>
          </Col>
          <Col md={8}>
            <h2>About me</h2>
            <p>{userdata.about}</p>
            <div className="profile_btn">
              <Link
                to={{ pathname: userdata.linkedin }}
                className="link_btn btn m-0"
                target="_blank"
              >
                <img
                  src={
                    imgPath + "linkedin.png"
                  }
                  className="me-2 bg-white"
                  alt="asdasd"
                />{" "}
                Linkedin Profile
              </Link>

              <div className="extar_info_link">
                <ul>
                  <li>
                    {userdata?.mf_mental_health == 1 && (
                      <Tooltip
                        size="4xl"
                        title={<h5>{config?.mf_mental_health}</h5>}
                        describeChild
                        arrow
                      >
                        <img alt="" src={imgPath + "usermind.svg"} />
                      </Tooltip>
                    )}
                  </li>
                  <li>
                    {userdata?.mf_certified_coach == 1 && (
                      <Tooltip
                        size="4xl"
                        title={<h5>{config?.mf_certified_coach}</h5>}
                        describeChild
                        arrow
                      >
                        <img alt="" src={imgPath + "usercoach.svg"} />
                      </Tooltip>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
        {userdata?.past_board_roles_data && userdata?.past_board_roles_data.length > 0 && (
          <Row className="mt-4">
            <Col md={12}>
              <h6 className="mb-3">Past Board Roles</h6>
              {userdata?.past_board_roles_data?.map((role) => (
                <div key={role.id} className="mb-3 p-2 border-start ps-3" style={{ borderLeftColor: '#007bff', borderLeftWidth: '3px' }}>
                  <p className="mb-1"><strong>{role.rep_company_name}</strong></p>
                  <p className="mb-1"><em>{role.rep_board_title}</em></p>
                  <p className="mb-0 text-muted" style={{ fontSize: '12px' }}>
                    {new Date(role.rep_start_date).toLocaleDateString()} - {new Date(role.rep_end_date).toLocaleDateString()}
                  </p>
                </div>
              ))}
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
};

Details.propTypes = {
  userdata: PropTypes.shape({
    full_name: PropTypes.string,
    position: PropTypes.string,
    organization: PropTypes.string,
    main_area: PropTypes.string,
    about: PropTypes.string,
    linkedin: PropTypes.string,
    image: PropTypes.string,
    mf_mental_health: PropTypes.number,
    mf_certified_coach: PropTypes.number,
    past_board_roles_data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        rep_company_name: PropTypes.string,
        rep_board_title: PropTypes.string,
        rep_start_date: PropTypes.string,
        rep_end_date: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default Details;
